import URLSearchParams from "url-search-params";

export const DEFAULT_LOCALE = "en";
export const SUPPORTED_LOCALES = ["en", "es"];
export const LOCALE_QUERY_PARAM = "merchantLocale";

// Anything but a supported locale counts as "no default".
export const normalizeLocale = value =>
  SUPPORTED_LOCALES.includes(value) ? value : null;

export const getBrowserLocale = (
  nav = typeof navigator !== "undefined" ? navigator : undefined
) => {
  const candidates = [];
  if (nav && Array.isArray(nav.languages)) {
    candidates.push(...nav.languages);
  }
  if (nav && nav.language) {
    candidates.push(nav.language);
  }
  for (const candidate of candidates) {
    const locale = normalizeLocale(
      String(candidate)
        .toLowerCase()
        .split("-")[0]
    );
    if (locale) {
      return locale;
    }
  }
  return DEFAULT_LOCALE;
};

export const getQueryLocale = search =>
  normalizeLocale(new URLSearchParams(search || "").get(LOCALE_QUERY_PARAM));

// The merchant's own choice wins, then the default the rep picked, then the
// browser. Nothing resolved here is ever written back to the application.
export const resolveLocale = ({ override, application, search, nav } = {}) =>
  normalizeLocale(override) ||
  normalizeLocale(application && application.merchantUiLocale) ||
  normalizeLocale(
    application && application.link && application.link.merchantUiLocale
  ) ||
  getQueryLocale(search) ||
  getBrowserLocale(nav);
